import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { Button, ButtonType, ButtonColor } from '@pegasus/ui-components/components/button';

import Translate from '@client/components/shared/translation/Translate';

import styles from './campaignOverlay.scss';

export function CampaignOverlay({ name, bannerText, dimension, hover }) {

    const classes = classNames(
        'wrapper',
        `wrapper-${dimension}`,
        {
            'wrapper-hover': hover
        }
    );

    return (
        <div styleName={classes}>
            <div styleName="info">
                <h5 styleName="info-header">{name}</h5>
                <p styleName="info-banner-text">{bannerText}</p>
                <Button color={ButtonColor.bright} buttonType={ButtonType.secondary} >
                    <Translate message="campaigns.ctaButtonText" />
                </Button>
            </div>
        </div>
    );
}

CampaignOverlay.propTypes = {
    name: PropTypes.string.isRequired,
    bannerText: PropTypes.string,
    dimension: PropTypes.string.isRequired,
    hover: PropTypes.bool
};

export default CSSModules(CampaignOverlay, styles, { allowMultiple: true });
